Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    spacing = _STYLES$useStyles.spacing;
  var announcements = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%'
  };
  var subsequentItem = {
    marginTop: spacing.normal
  };
  var announcement = {
    backgroundColor: COLORS.pipi,
    borderRadius: (0, _styles.getREM)(1),
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    width: '100%'
  };
  var announcement_image = {
    maxWidth: _styles.STYLES.grid.maxTextWidth
  };
  var announcementHeader = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: spacing.s
  };
  var text = {
    color: colors.text,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  };
  var textContainer = {
    marginBottom: 0
  };
  var announcementCloseContainer = {
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0
  };
  var announcementClose = {
    borderRadius: (0, _styles.getREM)(2.5)
  };
  var announcementCloseIconContainer = {
    height: (0, _styles.getREM)(2.5),
    width: (0, _styles.getREM)(2.5)
  };
  var primaryActionContainer = {
    alignItems: 'flex-start',
    marginTop: spacing.s
  };
  var primaryActionLabel = {
    paddingLeft: spacing.m,
    paddingRight: spacing.m
  };
  var announcementBackground = {
    maxWidth: '100%'
  };
  var announcementRow = {
    flexDirection: 'row',
    alignItems: 'flex-end'
  };
  var announcementContent = {
    flex: 1,
    padding: spacing.m
  };
  var styles = _reactNative.StyleSheet.create({
    announcement: announcement,
    announcement_image: announcement_image,
    announcementHeader: announcementHeader,
    announcements: announcements,
    subsequentItem: subsequentItem,
    text: text,
    textContainer: textContainer,
    announcementCloseContainer: announcementCloseContainer,
    announcementClose: announcementClose,
    announcementCloseIconContainer: announcementCloseIconContainer,
    primaryActionContainer: primaryActionContainer,
    primaryActionLabel: primaryActionLabel,
    announcementBackground: announcementBackground,
    announcementRow: announcementRow,
    announcementContent: announcementContent
  });
  return {
    styles: styles
  };
};